import { getLookingForChoiceIdByTitle } from '@/pages/Onboarding/options/LookingFor/utils/getLookingForChoice';
import { getPerfectLookChoiceIdByTitle } from '@/pages/Onboarding/options/PerfectLook/utils/getPerfectLookChoice';
import { getTurnsOnChoiceIdByTitle } from '@/pages/Onboarding/options/TurnsOn/utils/getTurnsOnChoice';

import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = {
  name?: string;
  email?: string;
  lookingFor?: string;
  turnsOn?: string;
  perfectLook?: string;
  personality?: {
    shy_dominant?: number;
    serious_flirty?: number;
    logical_emotional?: number;
    affectionate_independent?: number;
  };
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    name: onb_data.name || layoutDataDefault.name,
    email: onb_data.email || layoutDataDefault.email,
    looking_for: getLookingForChoiceIdByTitle(onb_data.lookingFor),
    turns_on: getTurnsOnChoiceIdByTitle(onb_data.turnsOn),
    perfect_look: getPerfectLookChoiceIdByTitle(onb_data.perfectLook),
    personality: {
      shy_dominant:
        onb_data.personality?.shy_dominant ||
        layoutDataDefault.personality.shy_dominant,
      serious_flirty:
        onb_data.personality?.serious_flirty ||
        layoutDataDefault.personality.serious_flirty,
      logical_emotional:
        onb_data.personality?.logical_emotional ||
        layoutDataDefault.personality.logical_emotional,
      affectionate_independent:
        onb_data.personality?.affectionate_independent ||
        layoutDataDefault.personality.affectionate_independent,
    },
  };
};
